import { Button } from '@/components/Button';
import { Callout } from '@/components/Callout';
import { useEnrolmentSession } from '@/lib/enrolmentSession';

import { ENROLMENT_COPY } from '../copy';
import { readySummary } from '../readySummary';
import { EnrolmentHeading } from './EnrolmentHeading';
import { EnrolmentShell } from './EnrolmentShell';

/**
 * Frame *09 · Ready* — the confirmation a staffer reads from arm's length before walking away [AC-5].
 *
 * ⭐ **The frame's content is `Heading` + a success `Callout` + `Start`, and nothing else** — read from the
 * node tree at 1440, 820 and 375 on 2026-09-16. The `Action link →` inside the callout is `visible: false`
 * at every width, and it is a slot default [[`0225`]].
 *
 * ✅ **G5 IS FIXED IN THE DESIGN, and this screen is built exactly as drawn.** The body used to read *"It
 * will show the welcome screen for candidates. You can change the site anytime from the admin panel."* — a
 * promise the product cannot keep, because under [0148] the venue comes only from the PIN, so moving a
 * device means re-enrolling it with the other venue's PIN. The second sentence is **gone from the canvas**
 * (re-read live 2026-09-16, all three widths) and nothing is omitted here.
 *
 * *Start* hands the device to the candidate-facing welcome [KID-1; 0125] — and from that tap onward the
 * product is bilingual [0026], where these three screens are not [[`0226`]].
 */
export function ReadyScreen() {
  const kioskName = useEnrolmentSession((state) => state.kioskName);
  const venueName = useEnrolmentSession((state) => state.venueName);
  const startTakingCandidates = useEnrolmentSession((state) => state.startTakingCandidates);

  const summary = readySummary(kioskName, venueName);

  return (
    <EnrolmentShell>
      <div className="flex w-full flex-col items-center gap-6 pb-8 pt-2">
        <EnrolmentHeading
          body={ENROLMENT_COPY.readyBody}
          eyebrow={ENROLMENT_COPY.readyEyebrow}
          heading={ENROLMENT_COPY.readyHeading}
        />

        {summary !== undefined && <Callout tone="success">{summary}</Callout>}

        <Button fullWidth onClick={startTakingCandidates}>
          {ENROLMENT_COPY.readyAction}
        </Button>
      </div>
    </EnrolmentShell>
  );
}
